export default __webpack_public_path__ + "static/media/backgroundOne.6ab04f52.png";